module.exports = __webpack_public_path__ + "img/logo_kr.53ca7a13.png";